// extracted by css-extract-rspack-plugin
export default {"createBranchLink":"NoBranchesOrLinkedPullRequests-module__createBranchLink__DJq8k6t"};